import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

/** Fetch all user profiles, sorted case-insensitively by username (display casing preserved). */
export async function listUserProfilesByName() {
  const snap = await getDocs(collection(db, 'userProfiles'));
  return snap.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .sort((a, b) =>
      (a.username || '').localeCompare(b.username || '', undefined, { sensitivity: 'base' })
    );
}
